var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('h1',{staticClass:"center-align dash-header"},[_vm._v("Lineage Independence Trust Program")]),_c('notifications-list',{attrs:{"notifications":_vm.notifications}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }